import { cn } from '@/libs/utils';

interface GradientSpinnerProps {
  size?: number;
  className?: string;
}

/**
 * Gradient spinner component for payment processing screens.
 * Uses the designer-provided gradient spinner SVG with smooth rotation.
 */
export function GradientSpinner({ size = 40, className }: GradientSpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('animate-spin', className)}
      style={{ animationDuration: '1.5s' }}
    >
      {/* Base ring - dark gray */}
      <path
        d="M30.5323 4.67388C32.9827 5.61926 35.2229 7.03802 37.125 8.84916C39.0271 10.6603 40.5538 12.8283 41.618 15.2295C42.6822 17.6307 43.2631 20.218 43.3274 22.8436C43.3917 25.4693 42.9382 28.0819 41.9928 30.5323C41.0474 32.9827 39.6287 35.2229 37.8175 37.125C36.0064 39.027 33.8384 40.5538 31.4372 41.618C29.036 42.6822 26.4487 43.263 23.8231 43.3273C21.1974 43.3917 18.5848 42.9382 16.1344 41.9928C13.684 41.0474 11.4438 39.6287 9.54175 37.8175C7.63966 36.0064 6.11293 33.8383 5.04872 31.4371C3.98451 29.036 3.40367 26.4487 3.33936 23.8231C3.27505 21.1974 3.72853 18.5848 4.67391 16.1344C5.61929 13.684 7.03805 11.4438 8.84919 9.54172C10.6603 7.63963 12.8284 6.1129 15.2296 5.04869C17.6307 3.98448 20.218 3.40364 22.8437 3.33933C25.4693 3.27502 28.0819 3.7285 30.5323 4.67388L30.5323 4.67388Z"
        stroke="#2D2D2D"
        strokeWidth="6.66667"
      />
      {/* Gradient overlay */}
      <path
        d="M30.5323 4.67388C32.9827 5.61926 35.2229 7.03802 37.125 8.84916C39.0271 10.6603 40.5538 12.8283 41.618 15.2295C42.6822 17.6307 43.2631 20.218 43.3274 22.8436C43.3917 25.4693 42.9382 28.0819 41.9928 30.5323C41.0474 32.9827 39.6287 35.2229 37.8175 37.125C36.0064 39.027 33.8384 40.5538 31.4372 41.618C29.036 42.6822 26.4487 43.263 23.8231 43.3273C21.1974 43.3917 18.5848 42.9382 16.1344 41.9928C13.684 41.0474 11.4438 39.6287 9.54175 37.8175C7.63966 36.0064 6.11293 33.8383 5.04872 31.4371C3.98451 29.036 3.40367 26.4487 3.33936 23.8231C3.27505 21.1974 3.72853 18.5848 4.67391 16.1344C5.61929 13.684 7.03805 11.4438 8.84919 9.54172C10.6603 7.63963 12.8284 6.1129 15.2296 5.04869C17.6307 3.98448 20.218 3.40364 22.8437 3.33933C25.4693 3.27502 28.0819 3.7285 30.5323 4.67388L30.5323 4.67388Z"
        stroke="url(#spinnerGradient)"
        strokeWidth="6.66667"
        strokeLinecap="square"
      />
      <defs>
        <linearGradient
          id="spinnerGradient"
          x1="4.67391"
          y1="16.1344"
          x2="41.9928"
          y2="30.5323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0046C8" />
          <stop offset="1" stopColor="#E6EDFA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
